var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{},[_c('select',{ref:"cmp",staticStyle:{"width":"100%","display":"none"},attrs:{"multiple":_vm.multiple ? 'multiple' : false}},[_vm._t("default")],2)])}
var staticRenderFns = []

export { render, staticRenderFns }